/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CounterPartyRow } from './counterPartyRow';


export interface CounterPartyRowPurpleTableResponse { 
    item: CounterPartyRow;
    expanded: boolean;
    toTranslate: boolean;
    isSelected: boolean;
}

